import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { DataService, parts2SKU, ProductRecord, SKU2Parts, ProductColorRecord, ProductUnit } from '@core/services/data.service';
import { ConfigsService } from '@core/services/configs.service';
import { SynchronizationService } from '@core/services/synchronization.service';

@Component({
  templateUrl: './product-editor.component.html',
  styleUrls: ['./product-editor.component.scss']
})
export class ProductEditorComponent implements OnInit {

  constructor(private ds: DataService, private configs: ConfigsService, private modal: ModalService, private sync: SynchronizationService) { }
  public loading = false;

  @Input()
  public product: ProductRecord;

  @Input()
  public onSucceed: (product: ProductRecord) => void;

  public producer: string;
  public code: string;

  public priceRetrived: boolean = false;

  public get valid(): boolean {
    return this.code.trim().length > 0 && this.product.UnitPrice >= 0 && this.product.ProfitMargin >= 0 && this.product.LogisticsMargin >= 0 && this.product.Colors.length > 0;
  }

  ngOnInit(): void {

    this.sync.when(ConfigsService).commit(() => {
      if (this.product == null) {
        this.product = { ID: 0, SKU: '', Unit: ProductUnit.Meter, AverageQuantity: 0, Colors: [], LogisticsMargin: this.configs.defaultLogisticsMargin, ProfitMargin: this.configs.defaultProfitMargin, UnitPrice: 0, IsPriceVerified: false }
      }
      else {
        this.product = { ...this.product };
      }


      let parts = SKU2Parts(this.product.SKU);

      this.producer = parts[0];
      this.code = parts[1];
    });    
  }

  public remove(color: ProductColorRecord) {
    this.product.Colors = this.product.Colors.filter(i => i != color);
  }

  public add(color: string) {
    color = color.toUpperCase().trim();
    if (color == '' || this.product.Colors.count(i => i.Color == color) > 0) return;

    this.product.Colors.push({ Color: color, Available: 0 });
  }

  public getPrice() {
    if (this.product.ID > 0 && this.product.UnitPrice == 0) {
      this.ds.products('last-import-price', this.product).subscribe(products => {
        if (products && products.length == 1) {          
          this.product.UnitPrice = products[0].UnitPrice;
          this.priceRetrived = true;
        }
      })
    }
  }

  public save() {

    this.loading = true;

    this.producer = this.producer.toUpperCase().replace(/([^A-Z0-9])+/i, '');
    this.code = this.code.toUpperCase().replace(/([^A-Z0-9])+/i, '');

    if (this.code == '') return;

    if (this.product.ID > 0) {
      this.ds.products('update', this.product).subscribe(results => {
        if (results) {
          for (let o in results[0]) this.product[o] = results[0][o];
          if (this.onSucceed) this.onSucceed(this.product);
          this.modal.of(this).hide();
        }
        this.loading = false;
      });
    }
    else {
      this.product.SKU = parts2SKU(this.producer, this.code);
      this.ds.products('create', this.product).subscribe(results => {
        if (results) {
          for (let o in results[0]) this.product[o] = results[0][o];
          if (this.onSucceed) this.onSucceed(this.product);
          this.modal.of(this).hide();
        }
        this.loading = false;
      });
    }
  }
}
